import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import { BrandErrorFragment } from "@saleor/fragments/types/BrandErrorFragment";
import { FormChange } from "@saleor/hooks/useForm";
import { BrandGroupClassification } from "@saleor/types/globalTypes";
import React from "react";
import { useIntl } from "react-intl";

import { BrandGroupFormData } from "../BrandGroupDetailsPage/BrandGroupDetailsPage";
export interface BrandGroupInfoProps {
  data: BrandGroupFormData;
  errors: BrandErrorFragment[];
  disabled: boolean;
  loading?: boolean;
  onChange: FormChange;
}

const BrandGroupInfo: React.FC<BrandGroupInfoProps> = props => {
  const intl = useIntl();
  const { data, onChange } = props;

  const classificationProperCase = type => {
    switch (type) {
      case BrandGroupClassification.FOOD_AND_BEVERAGES:
        return "Food and Beverages";
      case BrandGroupClassification.GENERAL_MERCHANDISE:
        return "General Merchandise";
      default:
        return " ";
    }
  };
  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "General Information",
            description: "section header"
          })}
        />
        <CardContent>
          <TextField
            label={intl.formatMessage({
              defaultMessage: "Brand",
              description: "brand"
            })}
            name="brand"
            disabled={true}
            value={data.name}
            onChange={onChange}
            fullWidth
          />
          <FormSpacer />
          <TextField
            label={intl.formatMessage({
              defaultMessage: "Classification",
              description: "classification"
            })}
            name="classification"
            disabled={true}
            value={classificationProperCase(data.classification)}
            onChange={onChange}
            fullWidth
          />
        </CardContent>
      </Card>
    </>
  );
};
BrandGroupInfo.displayName = "BrandGroupInfo";
export default BrandGroupInfo;
